import type { ImageProps } from "@chakra-ui/react";
import type { Variant } from "./types";

export const DISTANCE_BG = "https://img.airhelp.com/i/components/compensationCalculator/glob.png";

const imagePops = {
  position: "absolute" as const,
  width: "140px",
  top: 3,
  insetEnd: 0,
};
const overflowingImageProps = {
  ...imagePops,
  width: "156px",
  top: -5,
};

export const images: Record<Variant, ImageProps> = {
  celebration: { src: "https://img.airhelp.com/i/components/compensationCalculator/celebration.gif", ...imagePops },
  person: {
    src: "https://img.airhelp.com/i/components/compensationCalculator/person-with-money.png",
    ...overflowingImageProps,
  },
  icecream: {
    src: "https://img.airhelp.com/i/components/compensationCalculator/money-icecream.png",
    ...overflowingImageProps,
  },
} as const;

export const distanceRanges = [
  {
    distance: 0,
    compensation: 250,
    translationKey: "ec261_distance_range_1",
    marginBottom: 10,
  },
  {
    distance: 1500,
    compensation: 400,
    translationKey: "ec261_distance_range_2",
    marginBottom: "76px",
  },
  {
    distance: 3500,
    compensation: 600,
    translationKey: "ec261_distance_range_3",
    marginBottom: 28,
  },
] as const;
